module.exports = __webpack_public_path__ + "static/media/ic_jiohealthhub.4f6eecfb.svg";